import "src/decidim/assemblies/assemblies"
import "src/decidim/assemblies/orgchart"

// Images
require.context("../images", true)
